import { render } from "./ThePatientDocumentGrid.vue?vue&type=template&id=1f4b3efa&scoped=true&ts=true"
import script from "./ThePatientDocumentGrid.vue?vue&type=script&lang=ts"
export * from "./ThePatientDocumentGrid.vue?vue&type=script&lang=ts"

import "./ThePatientDocumentGrid.vue?vue&type=style&index=0&id=1f4b3efa&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4b3efa"]])

export default __exports__